import { DOCUMENT } from '@angular/common';
import { AfterViewInit, Directive, ElementRef, EventEmitter, OnDestroy, Output, inject } from '@angular/core';

@Directive({
    standalone: true,
    selector: '[bsClickOutsideOrScroll]',
})
export class ClickOutsideOrScrollDirective implements AfterViewInit, OnDestroy {
    @Output() bsClickOutsideOrScroll: EventEmitter<boolean> = new EventEmitter<boolean>();

    private readonly _doc = inject(DOCUMENT);

    constructor(private elementRef: ElementRef) {}

    ngAfterViewInit(): void {
        this._doc.addEventListener('click', this.onDocumentClick, true);
        this._doc.addEventListener('scroll', this.onDocumentScroll, true);
    }

    ngOnDestroy(): void {
        this._doc.removeEventListener('click', this.onDocumentClick);
        this._doc.removeEventListener('scroll', this.onDocumentScroll);
    }

    private onDocumentClick = (event: MouseEvent): void => {
        const clickedInside = this.elementRef.nativeElement.contains(event.target);

        if (!clickedInside) {
            this.bsClickOutsideOrScroll.emit(true);
        }
    };

    private onDocumentScroll = (): void => {
        this.bsClickOutsideOrScroll.emit(true);
    };
}
